<template lang="pug">
  .bg
    section.art-of-living#artofliving(data-type="parallax", data-depth="0.15")
      .art-of-living__container
        h1.art-of-living__heading(v-fade)
          .art-of-living__heading--gradient Искусство
          .art-of-living__heading--mono жить
        .art-of-living__text.text-body(v-fade) Искусство жить — это способность видеть мир по-своему, понимать и ценить каждый момент. 
          | Жизнь во всех красках откроется только тому, кто сам умеет создавать вокруг себя праздник. 
</template>

<script>
export default {
  name: "ArtOfLiving"
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.bg {
  background-color: $color-background;
}

.art-of-living {
  background-color: $color-background;
  width: 100%;

  &__container {
    margin: 0 auto;
    padding: 120px 0;
    width: 100%;
    box-sizing: border-box;

    @include from("lg") {
      padding: 13% 0 13%;
    }
    @include from("xxxl") {
      height: 73vh;
    }
  }

  &__heading {
    position: relative;
    box-sizing: border-box;
    margin-bottom: 45px;
    text-align: center;

    @include from("md") {
      margin-bottom: 85px;
    }

    &--gradient {
      font-family: $font-fmbolyarpro;
      text-align: center;
      text-transform: uppercase;
      background: $color-gradient;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 35px;
      line-height: 1.2;
      border: 1px solid $color-background;

      @include from("md") {
        font-size: 70px;
      }
      @include from("lg") {
        font-size: 80px;
      }
      @include from("xxxl") {
        font-size: 95px;
      }
    }
    &--mono {
      font-family: $font-mojito;
      text-align: center;
      position: absolute;
      font-size: 87px;
      transform: rotate(-5deg);
      bottom: -90%;

      left: 30%;

      @include from("sm") {
        font-size: 81px;
        bottom: -70%;
        left: 41%;
      }
      @include from("md") {
        font-size: 128px;
        bottom: -55%;
      }
      @include from("lg") {
        transform: rotate(-6deg);
        font-size: 160px;
        bottom: -60%;
        left: 34%;
      }
      @include from("xl") {
        left: 40%;
      }
      @include from("xxxl") {
        font-size: 183px;
        bottom: -60%;
        left: 45%;
      }
    }
  }

  &__text {
    text-align: center;
    padding: 0 40px;
    width: 100%;
    box-sizing: border-box;
    margin: auto;

    @include from("lg") {
      padding: 0;
      width: 55%;
    }

    @include from("xxxl") {
      width: 40%;
    }
  }
}

_:-ms-fullscreen,
:root .art-of-living__heading--gradient {
  color: #cab955;
  background: rgba(255, 255, 255, 0);
}
</style>
